<template>
  <div style="height:100%;">
    <el-card class="task-nav title-task-nav">
      <span>{{$route.meta.parent}}</span>
      <span>/</span>
      <span>{{$route.meta.title}}</span>
    </el-card>
    <el-card class="box-card page-box-card">
      <div class="all-bar">
        <div>
          <el-link
            :underline="false"
            :disabled="false"
            type="info"
            @click="$router.push('/index/template/taskTemplateChange/add')"
          >
            <span class="el-icon-plus"></span>
            <span>添加</span>
          </el-link>
          <el-link :underline="false" :disabled="selectionData.length==0" type="info" @click="deleteFormatFun(selectionData)">
            <span class="el-icon-delete"></span>
            <span>删除</span>
          </el-link>
        </div>
        <el-input
          placeholder="搜索"
          suffix-icon="el-icon-search"
          v-model="saveData.template_name"
          size="mini"
          style="width:266px"
          @change="getList"
        ></el-input>
      </div>
      <el-table
        :data="tableData"
        height="100%"
        @row-click="clickRow"
        ref="moviesTable"
        @selection-change="selectionChange"
        v-loading="loading"
        element-loading-text="拼命加载中"
      >
        <el-table-column type="selection"></el-table-column>
        <el-table-column prop="template_name" label="名称"></el-table-column>
        <el-table-column prop="template_describe" label="描述"></el-table-column>
        <el-table-column label="操作" width="50px" fixed="right"> 
          <template slot-scope="{row}">
            <el-dropdown>
              <span class="el-dropdown-link">
                <i class="el-icon-arrow-down el-icon-more"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>详情</el-dropdown-item>
                <el-dropdown-item @click.native="editFormatFun(row.template_format_id)">编辑</el-dropdown-item>
                <el-dropdown-item @click.native="deleteFormatFun([row])">删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="listTotal"
        :page-sizes="[10, 20, 30, 40, 50]"
        :current-page="saveData.pageIndex"
        @current-change="currentChangeFun"
        @size-change="sizeChange"
        :hide-on-single-page="true"
      ></el-pagination>
    </el-card>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { log } from "util";
export default {
  data() {
    return {
      listTotal: 0,
      test: 0,
      input1: "",
      tableData: [],
      loading:false,
      saveData: {
        pageIndex: 1,
        pageSize: 10,
        template_type: "transvideo",
        template_name: ""
      },
      selectionData: []
    };
  },
  created() {
    this.getList();
  },
  methods: {
    ...mapActions("format", ["getFormatListSto", "deleteFormatSto"]),
    //页码改变
    currentChangeFun(val) {
      this.saveData.pageIndex = val;
      this.getList();
    },
    //size改变
    sizeChange(val) {
      this.saveData.pageSize = val;
      this.getList();
    },
    // 选中行
    clickRow(row) {
      this.$refs.moviesTable.toggleRowSelection(row);
    },
    //获取列表
    getList() {
      this.loading=true
      this.getFormatListSto(this.saveData).then(({ data }) => {
        if (data.status == 0) {
          this.loading=false
          this.listTotal = data.data.total;
          this.tableData = data.data.list;
        }else{
          this.loading=false
        }
      }).catch(()=>{
        this.loading=false
      });
    },
    // 选中改变
    selectionChange(val) {
      this.selectionData = val;
    },
    // 删除
    deleteFormatFun(list) {
      let ids = list.map(val => {
        return val.template_format_id;
      });
      
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.deleteFormatSto({ template_format_id: ids.join(",") }).then(({ data }) => {
            if (data.status == 0) {
              this.$message.success("删除成功");
              this.getList();
            }
          });
        })
        .catch((err) => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //编辑
    editFormatFun(id){
     this.$router.push("/index/template/formatTemplateChange/edit/"+id)
    }
  }
};
</script>
<style>
.page-box-card {
  height: calc(100% - 110px);
}
.page-box-card .el-card__body {
  height: calc(100% - 110px);
}

</style>
<style scoped>
.all-bar {
  height: 28px;
  display: flex;
  justify-content: space-between;
}
.all-bar > div:nth-child(1) {
  height: 28px;
  display: flex;
}
.all-bar > div:nth-child(1) a {
  display: flex;
  margin-right: 20px;
}
.all-bar > div:nth-child(1) > span {
  height: 28px;
  line-height: 28px;
}
</style>